/* -------------------------------------------------------------------------
 * Sayuri fly-to-cart
 * -------------------------------------------------------------------------
 * When the Add-to-Cart button is clicked, spawn a flock of petals that
 * arc from the button to the cart icon in the header, bounce the bag,
 * and pop a "+1" near the cart.
 *
 * The function is idempotent and non-blocking — it listens but doesn't
 * interfere with the form submission. If the theme's existing cart
 * drawer JS intercepts the submit, the animation still plays; if not,
 * the page still navigates to /cart and the animation just overlaps.
 *
 * Respects prefers-reduced-motion (no particles; pulse only).
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sakura petal SVG — small 5-lobed shape
  function petalSVG(color) {
    return (
      '<svg viewBox="-14 -14 28 28" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M0,-11 C3,-8 4,-5 3,-2 L8,-2 C7,1 4,3 1,3 L3,8 C0,7 -2,5 -2,2 L-6,5 C-7,2 -6,-1 -3,-2 L-7,-6 C-5,-9 -2,-11 0,-11 Z" ' +
      'fill="' + color + '" opacity="0.95"/></svg>'
    );
  }

  function findBagIcon() {
    // Try common selectors in order. The real header cart control is the
    // VISIBLE toggle button (.header__icon--cart, aria-controls="CartDrawer");
    // there's also a hidden .no-js <a href="/cart"> fallback, so we (a) prefer
    // the visible button selectors first and (b) skip any hidden match — else
    // petals fly to the display:none anchor at (0,0).
    var selectors = [
      '[data-sayuri-bag]',
      '.header__icon--cart:not(.no-js)',
      '[data-js-toggle="CartDrawer"]',
      '.js-cart-toggle',
      '[data-cart-toggle]',
      'a[href="/cart"]',
      'a[href*="/cart"]:not([href*="/cart/"])',
      '.header__cart',
      '.header__icons a[aria-label*="cart" i]',
      '[aria-label*="cart" i]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        if (els[j].offsetParent !== null) return els[j]; // first VISIBLE match
      }
    }
    return null;
  }

  function rect(el) { return el.getBoundingClientRect(); }

  function spawnPetals(startX, startY, endX, endY, colors) {
    var count = 7;
    var layer = document.createElement('div');
    layer.className = 'sayuri-fly-layer';
    document.body.appendChild(layer);

    for (var i = 0; i < count; i++) {
      var petal = document.createElement('div');
      petal.className = 'sayuri-fly-petal';
      var color = colors[i % colors.length];
      petal.innerHTML = petalSVG(color);

      var size = 14 + Math.random() * 10;
      var delay = Math.random() * 120;
      var duration = 850 + Math.random() * 200;
      // Each petal gets a different mid-control-point for an arc
      var arcX = (startX + endX) / 2 + (Math.random() * 160 - 80);
      var arcY = Math.min(startY, endY) - (120 + Math.random() * 80);

      petal.style.setProperty('--p-start-x', startX + 'px');
      petal.style.setProperty('--p-start-y', startY + 'px');
      petal.style.setProperty('--p-arc-x', arcX + 'px');
      petal.style.setProperty('--p-arc-y', arcY + 'px');
      petal.style.setProperty('--p-end-x', endX + 'px');
      petal.style.setProperty('--p-end-y', endY + 'px');
      petal.style.setProperty('--p-dur', duration + 'ms');
      petal.style.setProperty('--p-delay', delay + 'ms');
      petal.style.setProperty('--p-spin', (Math.random() > 0.5 ? '' : '-') + (180 + Math.random() * 360) + 'deg');
      petal.style.width = size + 'px';
      petal.style.height = size + 'px';

      layer.appendChild(petal);
    }

    // Clean up when the longest animation finishes
    setTimeout(function () {
      if (layer.parentNode) layer.parentNode.removeChild(layer);
    }, 1600);
  }

  function pulseBag(bagEl) {
    bagEl.classList.add('sayuri-bag-pulse');
    setTimeout(function () { bagEl.classList.remove('sayuri-bag-pulse'); }, 800);

    // Small "+1" bubble near the bag
    var bubble = document.createElement('div');
    bubble.className = 'sayuri-bag-plusone';
    bubble.textContent = '+1';
    var r = rect(bagEl);
    bubble.style.left = (r.left + r.width / 2) + 'px';
    bubble.style.top = (r.top + r.height / 2) + 'px';
    document.body.appendChild(bubble);
    setTimeout(function () { if (bubble.parentNode) bubble.parentNode.removeChild(bubble); }, 1400);
  }

  function scentCloud(x, y, color) {
    var cloud = document.createElement('div');
    cloud.className = 'sayuri-scent-cloud';
    cloud.style.left = x + 'px';
    cloud.style.top = y + 'px';
    cloud.style.setProperty('--cloud-color', color || '#A43A72');
    document.body.appendChild(cloud);
    setTimeout(function () { if (cloud.parentNode) cloud.parentNode.removeChild(cloud); }, 1200);
  }

  function handleAddToCart(cta) {
    var bag = findBagIcon();
    if (!bag) return;

    var ctaR = rect(cta);
    var bagR = rect(bag);
    var startX = ctaR.left + ctaR.width / 2;
    var startY = ctaR.top + ctaR.height / 2;
    var endX = bagR.left + bagR.width / 2;
    var endY = bagR.top + bagR.height / 2;

    // Try to pull the scent accent color — default to plum
    var sig = document.querySelector('[data-sayuri-signature]');
    var palette = ['#A43A72', '#EFAAC4', '#FFC4D1', '#B8354A', '#C46A4B'];

    scentCloud(startX, startY);

    if (!REDUCED) {
      spawnPetals(startX, startY, endX, endY, palette);
    }

    // Delay the bag pulse slightly so it syncs with petal arrival
    setTimeout(function () { pulseBag(bag); }, REDUCED ? 0 : 700);
  }

  // Delegated click listener — CTA may re-render
  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest && e.target.closest('[data-sayuri-cta]');
    if (!cta || cta.disabled) return;
    // Let the form submission happen; kick off our animation alongside
    handleAddToCart(cta);
  }, true);
})();
